import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/independent-travel-product-list',
      name: 'admin-independent-travel-product-list',
      component: () => import(/* webpackChunkName: "page-admin-tourism-product-management-independent-travel-product-list" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "旅游自由行产品列表"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "旅游产品管理"
                                        },
                                        {
                                                  name: "旅游自由行产品列表"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
